import { MapperBase } from '../../utilities/mapper-base';
import { Issue } from '../ui/issue.model';
import { IssueResource } from '../resource/issue.resource';

export class IssueToIssueResourceMapper extends MapperBase<Issue, IssueResource> {
	map(source: Issue): IssueResource {
		const dest = {} as IssueResource;
		dest.issueId = source.id;
		dest.issueTitle = source.title;
		dest.description = source.description;
		return dest;
	}
}
